<template>
  <div>
    <Header page="my_page"/>
    <b-container class="mt-5">
      <b-row>
        <b-col cols="12" lg="3" class="mypage__sidebar">
          <SidebarMypage myPage="favorite"/>
        </b-col>
        <b-col cols="12" lg="9" class="pl-70">
          <b-navbar class="mypage__navbar">
            <b-collapse id="nav-collapse-employeeF" is-nav>
              <b-navbar-nav>
                <b-nav-item href="#" class="mypage__navlink"><span class="mypage__statistic">合計</span><span class="mypage__statistic__number mypage__statistic__number__green">{{metadataFavorite.total_files}}</span></b-nav-item>
                <b-nav-item href="#" class="mypage__navlink hidden-mb"><span class="mypage__statistic">PDF</span><span class="mypage__statistic__number mypage__statistic__number__pink">{{metadataFavorite.total_pdfs}}</span></b-nav-item>
                <b-nav-item href="#" class="mypage__navlink hidden-mb"><span class="mypage__statistic">画像</span><span class="mypage__statistic__number mypage__statistic__number__blue">{{metadataFavorite.total_images}}</span></b-nav-item>
                <b-nav-item href="#" class="mypage__navlink hidden-mb"><span class="mypage__statistic">動画</span><span class="mypage__statistic__number mypage__statistic__number__purple">{{metadataFavorite.total_videos}}</span></b-nav-item>
              </b-navbar-nav>
              <b-navbar-nav class="ml-auto">
                <button class="btn--filter" @click="listFile" :class="{active: popup}"><i class="icon-i-list"></i></button>
                <button class="btn--filter btn--filter--green" :class="{active: !popup}" @click="gridFile"><i class="icon-i-grid"></i></button>
              </b-navbar-nav>
            </b-collapse>
          </b-navbar>
          <ListFiles v-if="popup"/>
           <GridFiles v-else/>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import SidebarMypage from '@/views/Employee/MyPage/SidebarMypage'
import Header from '@/components/share/Header'
import GridFiles from '@/views/Employee/MyPage/GridFiles'
import ListFiles from '@/views/Employee/MyPage/ListFiles'
import {mapState} from 'vuex'
export default {
  name: 'FavoriteMypage',
  components: {
    Header,
    SidebarMypage,
    GridFiles,
    ListFiles
  },
  computed: {
    ...mapState({
      metadataFavorite: state => state.employeeMyPage.metadataFavorite
    })
  },
  mounted () {
    if (this.$route.query.tab === 'grid') {
      this.popup = false
    } else {
      this.popup = true
    }
    this.$store.dispatch('employeeMyPage/getFavorite')
  },
  methods: {
    listFile () {
      this.popup = true
      this.$router.push('/employee/me/favorite')
    },
    gridFile () {
      this.popup = false
      this.$router.push({
        path: '/employee/me/favorite',
        query: {tab: 'grid'}
      })
    }
  },
  data () {
    return {
      popup: true,
      items: [
        {
          text: 'ホーム',
          href: '#'
        },
        {
          text: 'マイページ',
          href: '#'
        },
        {
          text: 'お気に入り',
          active: true
        }
      ]
    }
  }
}
</script>
<style scoped lang="scss">
  @import "@/assets/stylesheet/mypage/detail_mypage.scss";
</style>



// WEBPACK FOOTER //
// src/views/Employee/MyPage/FavoriteMypage.vue